<div
    class="d-flex align-items-start justify-content-between"
    [ngClass]="{
        'h-100': !isScrolled
    }"
>
    <app-main-navigation></app-main-navigation>
    <div class="section-container flex-grow-1 bg-gray-300 ml-2 p-5">
        <router-outlet></router-outlet>
    </div>
</div>
